import React from "react";
import "./MaintenanceScreen.css";

const DEFAULT_TITLE = "We'll be right back";
const DEFAULT_MESSAGE =
  "Online ordering is paused for a quick spruce-up. Please try again in a little while — your coffee is worth the wait.";

/**
 * Full-screen takeover shown when the backend reports maintenance mode for this
 * cafe. Mirrors the mobile app's maintenance flow. Rendered by MenuList only on
 * the billing QR flow (?allowBilling=true); the regular menu is never blocked.
 *
 * Title/message come from the backend when it sends them, otherwise the copy
 * below is used.
 */
export default function MaintenanceScreen({ title, message, onRetry }) {
  return (
    <div className="maintenance-screen" role="alert" aria-live="assertive">
      <div className="maintenance-card">
        <div className="maintenance-art" aria-hidden="true">
          <svg viewBox="0 0 120 120" width="120" height="120">
            <circle cx="60" cy="60" r="58" className="maintenance-art-ring" />
            <path
              className="maintenance-art-cup"
              d="M38 46h38v18a19 19 0 0 1-19 19h0a19 19 0 0 1-19-19V46z"
            />
            <path
              className="maintenance-art-handle"
              d="M76 50h6a9 9 0 0 1 0 18h-6"
            />
            <path className="maintenance-art-steam" d="M50 34c-4-4 4-8 0-12" />
            <path className="maintenance-art-steam" d="M60 34c-4-4 4-8 0-12" />
            <path className="maintenance-art-steam" d="M70 34c-4-4 4-8 0-12" />
          </svg>
        </div>

        <h1 className="maintenance-title">{title || DEFAULT_TITLE}</h1>
        <p className="maintenance-message">{message || DEFAULT_MESSAGE}</p>

        {onRetry && (
          <button type="button" className="maintenance-retry" onClick={onRetry}>
            Try again
          </button>
        )}
      </div>
    </div>
  );
}
